import { Home, FileText, Link as LinkIcon, HardDrive, Wrench, LogOut } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import NavLink from './NavLink';
import { useAuthContext } from '../AuthProvider';

const navigation = [
  { icon: Home, label: '主页', path: '/' },
  { icon: FileText, label: '博客', path: '/blog' },
  { icon: LinkIcon, label: '导航', path: '/navigation' },
  { icon: HardDrive, label: '云盘', path: '/cloud' },
  { icon: Wrench, label: '工具', path: '/tools' },
];

export default function TopNav() {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuthContext();

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <div className="flex items-center space-x-4">
            {navigation.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                icon={item.icon}
                label={item.label}
                isActive={location.pathname === item.path}
              />
            ))}
          </div>
          
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                <Link
                  to="/admin"
                  className="text-sm text-indigo-600 hover:text-indigo-500"
                >
                  进入后台
                </Link>
                <button
                  onClick={() => logout()}
                  className="flex items-center space-x-1 text-sm text-gray-500 hover:text-gray-700"
                >
                  <LogOut className="w-4 h-4" />
                  <span>退出</span>
                </button>
              </>
            ) : (
              <Link
                to="/auth/login"
                className="text-sm text-indigo-600 hover:text-indigo-500"
              >
                登录
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}